import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { startCase } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastCtrl: ToastController) {}

  show(
    message: string,
    duration: number = 3000,
    cssClass: string = 'default-toast',
    position: string = 'top',
    showCloseButton?: boolean
  ) {
    this.toastCtrl.create({
      message: message,
      duration: duration,
      position: position as 'top' | 'middle' | 'bottom',
      cssClass: cssClass,
      buttons: showCloseButton ? [
        {
          text: 'Close',
          role: 'cancel',
        }
      ] : []
    }).then(async toastEl => {
      await toastEl.present();
    });
  }

  showDiaryEntryCompletedMessage(type: string, isUpdate = false) {
    const readableType = startCase(type).toLowerCase();
    if (isUpdate) {
      this.show(`You have updated your ${readableType}`);
    } else {
      this.show(`Thanks for adding your ${readableType}`);
    }
  }

  showTaskCompletedMessage(message: string = 'Nice job completing your Tasks, keep it up!') {
    this.show(message);
  }
}
